<div
  class="app-bar fg-white app-bar-expand"
  data-role="appbar"
  data-role-appbar="true"
  data-expand-point="md"
  [style.backgroundColor]="disabled ? '#6e6e6e' : '#0072c6'"
  [style.pointerEvents]="disabled ? 'none' : 'auto'"
  [style.opacity]="disabled ? '0.7' : '1'"
  [style.cursor]="disabled ? 'default' : 'default'"
>
  <!-- Contenedor del brand y menú hamburguesa -->
  <div class="brand-container">
    <!-- Hamburger menu - único control del menú -->
    <button
      class="hamburger-menu"
      (click)="!disabled && toggleDropdown()"
      (mouseenter)="!disabled && hoverDropdown(true)"
      (mouseleave)="!disabled && hoverDropdown(false)"
      [style.cursor]="disabled ? 'default' : 'pointer'"
      [class.active]="showDropdown"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>

    <!-- Texto del sistema - ahora sin funcionalidad -->
    <a class="brand no-hover">
      <span
        class="no-pointer border bd-white border-radius"
        style="width: 12rem; border: 1px solid; text-align: center"
      >
        SISTEMA DE PROYECTOS
      </span>
    </a>

    <!-- Menú desplegable -->
    <div
      class="dropdown-container"
      *ngIf="showDropdown && !disabled"
      (mouseleave)="!disabled && (showDropdown = false)"
    >
      <ul class="dropdown-menu">
        <li
          class="fg-white sp-options-menu"
          (click)="!disabled && RedirigiToDoList(); showDropdown = false"
          [ngClass]="{ 'sp-active': activeTodoList == true }"
        >
          <a class="fg-white" [ngClass]="{ 'text-bold': activeTodoList }"
            ><span class="mif-list fg-white"></span> ToDo List</a
          >
        </li>
        <li
          class="fg-white sp-options-menu"
          (click)="
            !disabled && RedirigirCarteraProyectos(); showDropdown = false
          "
          [ngClass]="{ 'sp-active': activeCarteraProy == true }"
        >
          <a class="fg-white" [ngClass]="{ 'text-bold': activeCarteraProy }"
            ><span class="mif-folder-open fg-white"></span> Cartera de
            Proyectos</a
          >
        </li>
        <li
          class="fg-white sp-options-menu"
          (click)="!disabled && RedirigirMantProyectos(); showDropdown = false"
          [ngClass]="{ 'sp-active': activeMantProy == true }"
        >
          <a class="fg-white" [ngClass]="{ 'text-bold': activeMantProy }"
            ><span class="mif-shareable fg-white"></span> Gerentes Asignados por
            Proyecto</a
          >
        </li>
        <li
          class="fg-white sp-options-menu"
          (click)="!disabled && Redirigir(); showDropdown = false"
          [ngClass]="{ 'sp-active': activeNewProject == true }"
        >
          <a class="fg-white" [ngClass]="{ 'text-bold': activeNewProject }"
            ><span class="mif-file-empty fg-white"></span> Nuevo Proyecto</a
          >
        </li>
        <li
          class="fg-white sp-options-menu"
          (click)="
            !disabled && RedirigirSponsorACrearObjetivos(); showDropdown = false
          "
          [ngClass]="{ 'sp-active': activeSponsor == true }"
        >
          <a class="fg-white" [ngClass]="{ 'text-bold': activeSponsor }"
            ><span class="mif-bookmark fg-white"></span> Sponsor y Objetivos
            Estratégicos</a
          >
        </li>
        <li
          *ngIf="infoUsuario.rolepersona?.Value === 1"
          class="fg-white sp-options-menu"
          (click)="
            !disabled && RedirigirReporteSuperUsuario(); showDropdown = false
          "
          [ngClass]="{ 'sp-active': activeReportSuperUsuario == true }"
        >
          <a
            class="fg-white"
            [ngClass]="{ 'text-bold': activeReportSuperUsuario }"
            ><span class="mif-bookmark fg-white"></span> Reporte Super
            Usuario</a
          >
        </li>
        <li
          *ngIf="
            infoUsuario.rolepersona?.Value === 1 ||
            infoUsuario.rolepersona?.Value === 6
          "
          class="fg-white sp-options-menu"
          (click)="!disabled && RedirigirMantenimiento(); showDropdown = false"
          [ngClass]="{ 'sp-active': activeMantenimiento == true }"
        >
          <a class="fg-white" [ngClass]="{ 'text-bold': activeMantenimiento }"
            ><span class="mif-cog fg-white"></span> Mantenimiento</a
          >
        </li>
      </ul>
    </div>
  </div>

  <!-- Menú invisible que mantiene el espacio -->
  <ul
    class="app-bar-menu collapsed invisible-menu"
    [style.backgroundColor]="disabled ? '#6e6e6e' : '#0072c6'"
    style="font-family: inherit"
    aria-hidden="true"
  >
    <li class="fg-white sp-options-menu">
      <a class="fg-white"><span class="mif-list fg-white"></span> ToDo List</a>
    </li>
    <li class="fg-white sp-options-menu">
      <a class="fg-white"
        ><span class="mif-folder-open fg-white"></span> Cartera de Proyectos</a
      >
    </li>
    <li class="fg-white sp-options-menu">
      <a class="fg-white"
        ><span class="mif-shareable fg-white"></span> Gerentes Asignados por
        Proyecto</a
      >
    </li>
    <li class="fg-white sp-options-menu">
      <a class="fg-white"
        ><span class="mif-file-empty fg-white"></span> Nuevo Proyecto</a
      >
    </li>
    <li class="fg-white sp-options-menu">
      <a class="fg-white"
        ><span class="mif-bookmark fg-white"></span> Sponsor y Objetivos
        Estratégicos</a
      >
    </li>
    <li
      *ngIf="infoUsuario.rolepersona?.Value === 1"
      class="fg-white sp-options-menu"
    >
      <a class="fg-white"
        ><span class="mif-bookmark fg-white"></span> Reporte Super Usuario</a
      >
    </li>
    <li
      *ngIf="
        infoUsuario.rolepersona?.Value === 1 ||
        infoUsuario.rolepersona?.Value === 6
      "
      class="fg-white sp-options-menu"
    >
      <a class="fg-white"
        ><span class="mif-cog fg-white"></span> Mantenimiento</a
      >
    </li>
  </ul>
</div>
